module.exports = __webpack_public_path__ + "img/photo-0129.7b6c394d.jpg";